import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services-vendors',
  templateUrl: './services-vendors.component.html',
  styleUrls: ['./services-vendors.component.css']
})
export class ServicesVendorsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
